import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Alert,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Category } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import BannerImage from "../../component/admin/professionalTournaments/BannerImage";
import BannerForm from "../../component/admin/formComponents/BannerForm";
import moment from "moment";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

export default function Goals() {
  const token = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      category: "default",
      image: "",
      previous_months: moment().format("YYYY-MM"),
      type: null,
    },
    validationSchema: Yup.object().shape({
      category: Yup.number("Please enter integer value")
        .required("Category is Required")
        .typeError("Category is Required"),
      image: Yup.mixed().required("Banner Image is required"),
      previous_months: Yup.date()
        .typeError("Please select previous months")
        .when("category", {
          is: 6,
          then: (schema) => schema.required("Please Enter Previous Months"),

          otherwise: (schema) => {},
        }),
      type: Yup.string()
        .nullable()
        .when("category", {
          is: (value) => [1, 2, 3, 5, 6].includes(value),
          then: (schema) => schema.required("Please select the type"),

          otherwise: (schema) => {},
        }),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("category", values.category);
      data.append("image", values.image);
      data.append("type", values.type);

      if (values.category == 6) {
        data.append("prev_month", values.previous_months);
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/createBanner`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (response.data.success) {
          toast.success(response.data.message);
          //   toast.success(test);
          navigate("/admin/dashboard/banners");
        } else {
          toast.error(response.data.message);
        }
      } catch (e) {
        toast.error("error !!");
      } finally {
        setLoading(false);
      }
    },
  });


  return (
    <React.Fragment>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress sx={{ color: "#ef364e" }} />
      </Backdrop>
      <Box className="free_votes_page">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            Create Banner
          </Typography>
        </Box>

        <BannerForm formik={formik} edited={false} />
      </Box>
    </React.Fragment>
  );
}
